import './Banner.css';
import Banner from './Banner';

export default Banner;



// WEBPACK FOOTER //
// ./src/components/Banner/index.js